export const SECTION_TYPES = {
  COURSE_GROUP_LIST: "course-group-list",
  SIMPLE_WYSIWYG: "simple-wysiwyg-section",
  TWO_COLUMNS_WYSIWYG: "two-columns-wysiwyg-section",
  IMAGE_CONTENT: "image-content-section",
  IMAGES_CARDS: "images-cards-section",
  LOGOS_SECTION: "logos-section",
  SIMPLE_BG_IMAGE: "simple-bgimage-section",
  CLASSIC_HERO: "classic-hero-section",
  DYNAMIC_SECTION: "dynamic-section",
  MAIN_PAGE_HERO: "main-page-hero-section",
  PRODUCTS_SECTION: "products-section",
  MAP_SECTION: "map-section",
  OPINIONS_SECTION: "opinions-section",
  CONTACT_LOCATIONS: "contact-locations-section",
  CONTACT_FORM: "contact-form-section",
  PEOPLE_SECTION: "people-section",
  CARDS_SECTION: "cards-section",
  STATIC_PDF: "static-pdf-section",
  VIDEO_SECTION: "video-section",
  VIDEO_CONTENT_CARDS: "video-content-cards-section",
  COURSE_HERO: "course-hero",
  COURSE_ENROLLMENT: "course-enrollment",
  COURSE_TABS: "course-tabs",
  COURSE_STICKY_BAR: "course-sticky-bar",
  MOBILE_STICKY_CTA: "mobile-sticky-cta",
  BLOG_QUOTE: "blog-quote-section",
} as const;

export type SectionType = (typeof SECTION_TYPES)[keyof typeof SECTION_TYPES];

export const SECTION_TYPE_LABELS: Record<SectionType, string> = {
  [SECTION_TYPES.COURSE_GROUP_LIST]: "Lista grup kursów",
  [SECTION_TYPES.SIMPLE_WYSIWYG]: "Sekcja WYSIWYG",
  [SECTION_TYPES.TWO_COLUMNS_WYSIWYG]: "Sekcja WYSIWYG - 2 kolumny",
  [SECTION_TYPES.IMAGE_CONTENT]: "Sekcja obraz + treść",
  [SECTION_TYPES.IMAGES_CARDS]: "Karty obrazów",
  [SECTION_TYPES.LOGOS_SECTION]: "Sekcja z logotypami",
  [SECTION_TYPES.SIMPLE_BG_IMAGE]: "Sekcja z obrazem w tle",
  [SECTION_TYPES.CLASSIC_HERO]: "Sekcja hero",
  [SECTION_TYPES.DYNAMIC_SECTION]: "Sekcja dynamiczna",
  [SECTION_TYPES.MAIN_PAGE_HERO]: "Sekcja hero strony głównej",
  [SECTION_TYPES.PRODUCTS_SECTION]: "Sekcja produktów",
  [SECTION_TYPES.MAP_SECTION]: "Sekcja z mapą",
  [SECTION_TYPES.OPINIONS_SECTION]: "Sekcja z opiniami",
  [SECTION_TYPES.CONTACT_LOCATIONS]: "Sekcja lokalizacji kontaktowych",
  [SECTION_TYPES.CONTACT_FORM]: "Sekcja formularza kontaktowego",
  [SECTION_TYPES.PEOPLE_SECTION]: "Sekcja z osobami",
  [SECTION_TYPES.CARDS_SECTION]: "Sekcja kart",
  [SECTION_TYPES.STATIC_PDF]: "Strona PDF",
  [SECTION_TYPES.VIDEO_SECTION]: "Sekcja wideo",
  [SECTION_TYPES.VIDEO_CONTENT_CARDS]: "Sekcja wideo + treść + karty",
  [SECTION_TYPES.COURSE_HERO]: "Hero kursu",
  [SECTION_TYPES.COURSE_ENROLLMENT]: "Zapisy na kurs",
  [SECTION_TYPES.COURSE_TABS]: "Zakładki kursu",
  [SECTION_TYPES.COURSE_STICKY_BAR]: "Sticky bar kursu",
  [SECTION_TYPES.MOBILE_STICKY_CTA]: "Mobilny sticky CTA",
  [SECTION_TYPES.BLOG_QUOTE]: "Cytat (blog)",
};

export const SECTION_TYPE_OPTIONS = Object.entries(SECTION_TYPE_LABELS)
  .filter(([value]) => value !== SECTION_TYPES.BLOG_QUOTE)
  .map(([value, label]) => ({
    value,
    label,
  }));

export const COURSE_DETAIL_SECTION_TYPE_OPTIONS = Object.entries(SECTION_TYPE_LABELS)
  .filter(([value]) => value !== SECTION_TYPES.BLOG_QUOTE)
  .map(([value, label]) => ({
    value,
    label,
  }));

export const BLOG_SECTION_TYPE_OPTIONS = [
  SECTION_TYPES.SIMPLE_WYSIWYG,
  SECTION_TYPES.IMAGE_CONTENT,
  SECTION_TYPES.IMAGES_CARDS,
  SECTION_TYPES.VIDEO_SECTION,
  SECTION_TYPES.VIDEO_CONTENT_CARDS,
  SECTION_TYPES.BLOG_QUOTE,
].map((value) => ({
  value,
  label: SECTION_TYPE_LABELS[value],
}));
